import { booksData } from '../../../mocks/books';

const BooksList = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-24">
          {booksData.map((book, index) => (
            <div
              key={book.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-dense' : ''
              }`}
            >
              {/* Book Cover */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="relative">
                  <div className="bg-gradient-to-br from-[#F5E6D3] to-[#E8D4B8] rounded-3xl p-12 shadow-2xl">
                    <img
                      src={book.coverImage}
                      alt={book.title}
                      className="w-full h-auto object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-300"
                      style={{ transform: 'perspective(1000px) rotateY(-5deg)' }}
                    />
                  </div>
                  {/* Decorative Element */}
                  <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-[#D4AF37] rounded-full opacity-20 blur-3xl"></div>
                </div>
              </div>

              {/* Book Details */}
              <div className={`${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                <p className="text-xs text-[#D4AF37] font-semibold uppercase tracking-widest mb-3">
                  {book.category}
                </p>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-3 leading-tight">
                  {book.title}
                </h2>
                <p className="text-lg text-gray-600 italic mb-5">{book.subtitle}</p>

                {/* Theme Tags */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {book.themes.map((theme, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-white border-2 border-[#1B3A52] text-[#1B3A52] rounded-full text-xs font-medium"
                    >
                      {theme}
                    </span>
                  ))}
                </div>

                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  {book.description}
                </p>

                {/* Available Formats */}
                <div className="mb-6">
                  <p className="text-sm font-semibold text-[#1B3A52] mb-2">Available Formats:</p>
                  <div className="flex flex-wrap gap-2">
                    {book.formats.map((format, idx) => (
                      <span
                        key={idx}
                        className="px-4 py-2 bg-[#F5E6D3] text-[#1B3A52] rounded-lg text-sm font-medium"
                      >
                        {format}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 items-start">
                  <a
                    href={book.amazonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-[#1B3A52] text-white px-7 py-3 rounded-full text-base font-medium hover:bg-[#2a5270] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    Buy on Amazon
                    <i className="ri-external-link-line"></i>
                  </a>
                  <div className="flex flex-col justify-center">
                    <p className="text-xl font-bold text-[#1B3A52]">{book.price}</p>
                    <p className="text-xs text-gray-500">Starting Price</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bundle Offer Section */}
        <div className="mt-24 bg-gradient-to-br from-[#1B3A52] to-[#2a5270] rounded-3xl p-10 md:p-12 text-white relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#D4AF37] rounded-full opacity-10 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full opacity-5 blur-2xl"></div>
          
          <div className="relative z-10 text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#D4AF37] rounded-full mb-5">
              <i className="ri-gift-line text-3xl text-white"></i>
            </div>
            
            <h3 className="text-3xl md:text-4xl font-serif font-bold mb-5">
              Complete Collection Bundle
            </h3>
            
            <p className="text-lg md:text-xl mb-3 text-[#F5E6D3]">
              Get All 7 Books at a Special Price
            </p>
            
            <p className="text-base mb-6 text-gray-200 leading-relaxed">
              Transform your spiritual journey with Pastor Don R. Vining's complete collection. 
              From understanding salvation to engaging in spiritual warfare, this bundle covers 
              essential teachings for every believer.
            </p>

            {/* Bundle Contents */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6">
              <h4 className="text-lg font-semibold mb-3 text-[#D4AF37]">Bundle Includes:</h4>
              <ul className="text-left space-y-2 max-w-2xl mx-auto">
                {booksData.map((book) => (
                  <li key={book.id} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#D4AF37] text-lg mt-1 flex-shrink-0"></i>
                    <span className="text-base">{book.title}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Information */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6">
              <h4 className="text-xl font-semibold mb-5">Contact Leavitt Peak Press for Special Pricing</h4>
              
              <div className="grid md:grid-cols-2 gap-5 max-w-3xl mx-auto">
                <a 
                  href="mailto:info@leavittpeakpress.com"
                  className="flex items-center gap-4 bg-white/10 hover:bg-white/20 transition-all rounded-xl p-4 cursor-pointer"
                >
                  <div className="w-11 h-11 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-white"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-xs text-gray-300 mb-1">Email Us</p>
                    <p className="text-base font-medium">info@leavittpeakpress.com</p>
                  </div>
                </a>

                <a 
                  href="tel:+18885490988"
                  className="flex items-center gap-4 bg-white/10 hover:bg-white/20 transition-all rounded-xl p-4 cursor-pointer"
                >
                  <div className="w-11 h-11 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-white"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-xs text-gray-300 mb-1">Call Us</p>
                    <p className="text-base font-medium">1-888-549-0988</p>
                  </div>
                </a>
              </div>
            </div>

            <p className="text-xs text-gray-300">
              Bulk orders and church group discounts available. Contact us for more information.
            </p>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-24 text-center bg-[#F5E6D3] rounded-3xl p-10 md:p-12">
          <div className="w-14 h-14 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-5">
            <i className="ri-headphone-line text-2xl text-white"></i>
          </div>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#1B3A52] mb-5">
            Prefer Audiobooks?
          </h3>
          <p className="text-base text-gray-700 mb-6 max-w-2xl mx-auto">
            Listen to these books in audio format. Perfect for your commute, workout, or quiet time with God.
          </p>
          <a
            href="/audiobooks"
            className="inline-block bg-[#1B3A52] text-white px-8 py-3 rounded-full text-base font-medium hover:bg-[#2a5270] transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Browse Audiobooks →
          </a>
        </div>
      </div>
    </section>
  );
};

export default BooksList;
